<cc-data-grid-features
    [stateConfig]="{ storageKey: storageKey, storeGroupings: true }"
    [dataSource]="invoiceGridSource"
>
    <dx-data-grid
        #invoiceGrid
        width="100%"
        height="100%"
        keyExpr="workFlowId"
        [dataSource]="invoiceGridSource"
        (onContentReady)="onGridContentReady($event)"
        (onSelectionChanged)="onGridSelectionChanged($event)"
    >
        <dxo-selection mode="multiple" showCheckBoxesMode="always"></dxo-selection>

        <dxi-column
            dataField="workFlowId"
            dataType="number"
            caption="Work Flow Id"
            cellTemplate="workflowIdTemplate"
        ></dxi-column>
        <dxi-column dataField="invoiceNumber" dataType="string" caption="Invoice #"></dxi-column>
        <dxi-column
            dataField="invoiceAmount"
            dataType="number"
            caption="Invoice Amount"
            [format]="currencyFormat"
        ></dxi-column>
        <dxi-column dataField="invoiceDate" dataType="date" caption="Invoice Date" [format]="dateFormat"></dxi-column>
        <dxi-column dataType="string" alignment="center" caption="Invoice" cellTemplate="invoiceTemplate"></dxi-column>
        <dxi-column dataField="vendorName" dataType="string" caption="Vendor"></dxi-column>

        <div *dxTemplate="let row of 'invoiceTemplate'">
            <i class="cc-1-5x cc-red-icon icon-content" [ngClass]="iconPDF" (click)="onInvoiceClick(row.data)"></i>
        </div>

        <div *dxTemplate="let row of 'workflowIdTemplate'">
            <div class="cell-link-content">
                <a href="javascript:void(0);" (click)="onWorkFlowClick(row.data)">{{ row.value }}</a>
            </div>
        </div>
    </dx-data-grid>
</cc-data-grid-features>

<app-workflow-viewer
    *ngIf="showWorkflowViewer"
    [viewOnly]="true"
    [workflowId]="selectedWFWorkOrder.workFlowId"
    [communityId]="communityId"
    (onClose)="onWorkflowViewerClose()"
></app-workflow-viewer>
